import Button from 'components/shared/button';
import { X } from 'lucide-react';
import { LoanEstimateResponseTypes } from '.';
import { normalizeMoney } from './utis';

interface LoanEstimateProps {
  onClose: () => void;
  data: LoanEstimateResponseTypes;
  email: string;
  transport?: boolean;
  onApply: () => void;
}
const LoanCalculatorEstimate = ({
  onClose,
  onApply,
  data,
  email,
  transport,
}: LoanEstimateProps) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/20">
      <article className="w-[90vw] max-w-xl p-6 space-y-4 rounded-lg bg-white">
        <div className=" flex justify-end mb-6">
          <button className="cursor-pointer text-[#FF3B30]" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        <div className="bg-[#F0EDFF] p-6 rounded-lg">
          <p>
            Based on your monthly income and selected loan type, we can offer
            you an estimated loan of
            <span className="font-semibold">
              {' '}
              ₦{data?.approvedLoanAmount?.toLocaleString() ?? ''}{' '}
            </span>
            to be repaid in{' '}
            {data?.durationInMonths > 1
              ? `${data.durationInMonths} months`
              : `${data?.durationInMonths} month`}
            .
          </p>
        </div>

        {transport && (
          <div className="p-2.5 w-full bg-[#F0EDFF] rounded-lg mt-6 text-sm flex items-center gap-4">
            <span className="size-6 flex items-center justify-center bg-[#31005C] rounded-full text-white font-medium text-lg">
              !
            </span>
            <p className="text-[#616161]">
              The maximum amount you can get for transport loan is{' '}
              <span className="font-medium">₦120,000.00 </span>
            </p>
          </div>
        )}
        <p className="md:text-lg text-center p-4 md:p-6 text-[#616161] leading-[140%]">
          An email containing the details for this loan calculator has been sent
          to <span className="font-semibold">{email ?? ''}</span>
        </p>

        <div className="mt-10 flex flex-col gap-4">
          <Button
            className="w-full h-[50px] flex items-center justify-center rounded-3xl"
            type="submit"
            onClick={onApply}
          >
            Apply for Loan
          </Button>
          <Button
            onClick={onClose}
            className="w-full bg-white border border-BrandPrimary h-[50px] flex items-center justify-center rounded-3xl text-BrandPrimary"
            type="submit"
          >
            Close
          </Button>
        </div>
      </article>
    </div>
  );
};

export default LoanCalculatorEstimate;
